import { Component, OnInit } from '@angular/core';
import { POWER_BI_REPORT_LABEL } from '../powerbi.constants';
import { SessionService } from 'src/app/services/session.service';

@Component({
  selector: 'app-powerbi-module-embed',
  templateUrl: './powerbi-module-embed.component.html',
  styleUrls: ['./powerbi-module-embed.component.scss'],
})
export class PowerBiModuleEmbedComponent implements OnInit {
  reportName = POWER_BI_REPORT_LABEL;
  clientLogo: any;
  newColor: any;

  constructor(private readonly sessionService: SessionService) {}

  ngOnInit(): void {
    this.clientLogo = this.sessionService.getClintLogo();
    this.newColor = this.sessionService.getColorCodes();
  }
}
